<template>
  <div class="delivery-time-component">
    <v-btn
      class="button fullwidth mb-5"
      depressed
      :ripple="false"
      @click="increase"
    >
      <font-awesome-icon icon="chevron-up" />
    </v-btn>
    <div class="time-section d-flex align-center justify-space-between">
      <vue-timepicker
        v-model="timeFrom"
        :minute-interval="15"
        hide-clear-button
        auto-scroll
        @close="updateValues"
      />
      <!--      :hour-range="[timeFrom.HH, timeTo.HH]"-->
      <span class="hyphen font-weight-medium">–</span>
      <vue-timepicker
        v-model="timeTo"
        disabled
        :minute-interval="15"
        hide-clear-button
      />
    </div>
    <v-btn
      class="button fullwidth mt-5"
      depressed
      :ripple="false"
      @click="decrease"
    >
      <font-awesome-icon icon="chevron-down" />
    </v-btn>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  import VueTimepicker from 'vue2-timepicker'
  import 'vue2-timepicker/dist/VueTimepicker.css'
  import { formatIsoDateTime } from '@/util/date-time-helper'

  export default {
    name: 'DeliveryTime',
    components: {
      VueTimepicker,
    },
    props: {
      isSameDay: Boolean,
    },
    data () {
      return {
        timeFrom: {
          HH: '00',
          mm: '00',
        },
        timeTo: {
          HH: '00',
          mm: '00',
        },
        seconds: 0,
        minTime: 0,
        maxTime: 81000, // пересчитывается в setInitTime
      }
    },
    watch: {
      isSameDay () {
        this.setInitTime()
        this.updateTime()
      },
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
      }),
      filial () {
        return (this.basket && this.basket.filial) || null
      },
      // окно предзаказа в секундах от начала дня: [открытие + 15 мин, закрытие - 15 мин],
      // ночная смена (закрытие за полночь) обрезается слотом 23:45
      workBounds () {
        const SLOT = 900
        const toSeconds = t => {
          const [hours, minutes] = t.split(':').map(Number)
          return hours * 3600 + minutes * 60
        }
        const start = (this.filial && this.filial.startTime) || '11:30'
        const end = (this.filial && this.filial.endTime) || '22:30'
        const overnight = end <= start
        const openBound = toSeconds(start) + 15 * 60
        const closeBound = overnight ? 23 * 3600 + 45 * 60 : toSeconds(end) - 15 * 60
        return {
          min: Math.ceil(openBound / SLOT) * SLOT,
          max: Math.floor(closeBound / SLOT) * SLOT,
        }
      },
    },
    mounted () {
      this.setInitTime()
      if (this.basket.toDatetime) {
        this.$nextTick(() => {
          this.setTimeFromBasket()
        })
      }
    },
    methods: {
      // секунды «сейчас» от начала дня в таймзоне филиала (timeZone вида "UTC+7"),
      // fallback - часы браузера
      filialNowSeconds () {
        let now = moment()
        const tz = this.filial && this.filial.timeZone
        const match = tz && tz.match(/UTC([+-]?\d{1,2})(?::(\d{2}))?/)
        if (match) {
          const hours = parseInt(match[1], 10)
          const minutes = match[2] ? parseInt(match[2], 10) : 0
          now = moment().utcOffset(hours * 60 + Math.sign(hours) * minutes)
        }
        return now.hours() * 3600 + now.minutes() * 60
      },
      setInitTime () {
        const SLOT = 900
        let bound = this.workBounds.min
        if (this.isSameDay) {
          const nowBound = Math.ceil((this.filialNowSeconds() + 15 * 60) / SLOT) * SLOT
          bound = Math.max(bound, nowBound)
        }
        this.minTime = Math.min(bound, this.workBounds.max)
        this.maxTime = this.workBounds.max
        this.seconds = this.minTime
        this.convertSeconds()
        this.updateTime()
      },
      updateValues (value) {
        this.timeFrom.HH = value.data.HH
        this.timeFrom.mm = value.data.mm
        const picked = this.timeFrom.HH * 3600 + this.timeFrom.mm * 60
        this.seconds = Math.min(Math.max(picked, this.minTime), this.maxTime)
        this.convertSeconds()
        this.updateTime()
      },
      increase () {
        if (this.seconds + 900 <= this.maxTime) {
          this.seconds += 900
          this.convertSeconds()
          this.updateTime()
        }
      },
      decrease () {
        if (this.seconds - 900 >= this.minTime) {
          this.seconds -= 900
          this.convertSeconds()
          this.updateTime()
        }
      },
      convertSeconds () {
        let hours = `${Math.floor((this.seconds / 60) / 60)}`
        let minutes = ((this.seconds / 60) % 60).toFixed(0)
        if (hours.length === 1) {
          hours = '0' + hours
        }
        if (minutes.length === 1) {
          minutes = '0' + minutes
        }
        const secondTimeSeconds = this.seconds + 1800
        let secondHours = `${Math.floor((secondTimeSeconds / 60) / 60)}`
        let secondMinutes = ((secondTimeSeconds / 60) % 60).toFixed(0)
        if (secondHours.length === 1) {
          secondHours = '0' + secondHours
        }
        if (secondMinutes.length === 1) {
          secondMinutes = '0' + secondMinutes
        }
        this.timeTo.HH = secondHours > 23 ? '00' : secondHours
        this.timeTo.mm = secondMinutes
        this.timeFrom.HH = hours
        this.timeFrom.mm = minutes
      },
      updateTime () {
        this.$emit('on-update', {
          timeFrom: this.timeFrom,
          timeTo: this.timeTo,
        })
      },
      setTimeFromBasket () {
        // const hours = moment(this.basket.dateDelivery, 'YYYY-MM-DD HH:mm:ss').format('HH')
        // const minutes = moment(this.basket.dateDelivery, 'YYYY-MM-DD HH:mm:ss').format('mm')
        const hours = formatIsoDateTime(this.basket.dateDelivery, 'HH')
        const minutes = formatIsoDateTime(this.basket.dateDelivery, 'mm')
        this.seconds = hours * 3600 + minutes * 60
        this.convertSeconds()
        this.updateTime()
      },
    },
  }
</script>

<style lang="less" scoped>
  .delivery-time-component {
    .button {
      height: 94px;
      border-radius: 10px;
      background-color: #F1F3F6 !important;

      svg {
        width: 75px;
        height: 75px;
      }
    }

    .time-section {
      .hyphen {
        margin: 0 15px;
        font-size: 32px;
      }
    }

    ::v-deep {
      .vue__time-picker {
        width: 100%;
        flex: 1;

        &:first-child {
          input {
            border-color: @color-primary;
          }
        }

        input {
          width: 100%;
          text-align: center;
          border: 2px solid;
          border-radius: 15px;
          height: 94px;
          font-size: 48px;
          outline: none;

          // компактный десктоп: при 48px время не помещалось в поле («21:0»);
          // 28px влезает и в самое узкое поле, на 1025px
          .media-compact-pc({
            font-size: 28px;
          });

          &:disabled {
            color: #000000;
          }
        }

        .dropdown.drop-down {
          top: 100%;
          width: 100%;

          .select-list {
            width: 100%;
          }

          li.active {
            background-color: @color-primary;
          }

          .hours, .minutes {
            flex: 1;
            width: 100%;
            font-size: 20px;
          }
        }
      }
    }
  }
</style>
